var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kvass-media-types-help-trigger"},[_c('ButtonComponent',{attrs:{"label":`${_vm.$t('tourVideoUpload')} ? `,"tag":"a","target":"_blank","href":`https://help.kvass.no/nb/articles/${_vm.triggerId}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }